import { render } from "./SchoolInquiryModal.vue?vue&type=template&id=77c6eb02&scoped=true"
import script from "./SchoolInquiryModal.vue?vue&type=script&lang=js"
export * from "./SchoolInquiryModal.vue?vue&type=script&lang=js"

import "./SchoolInquiryModal.vue?vue&type=style&index=0&id=77c6eb02&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c6eb02"]])

export default __exports__